/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @module
 * @description
 * Entry point for all public APIs of the http package.
 */
export * from './src/index';

// This file only reexports content of the `src` folder. Keep it that way.

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
